import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const BreadcrumbItemContent = ({ item }) => {
  const intl = useIntl();
  if (item.messageId) {
    return intl.formatMessage({ id: item.messageId });
  }
  if (item.icon) {
    return <Icon name={item.icon} />;
  }
  if (item.ellipsis) {
    return intl.formatMessage({ id: 'ellipses' });
  }
  return item.name;
};

export default BreadcrumbItemContent;
